/** Admin authentication endpoints (SPEC §5.10 admin-auth, §5.1 refresh/logout). */
import { http } from '@/api/http';
import type { AdminMe, AdminOtpVerifyResponse, OtpRequestResponse } from '@/api/types';

export const authKeys = {
  me: ['admin', 'me'] as const,
};

/** Same response for staff and non-staff addresses; the code is only sent to staff. */
export async function requestAdminOtp(email: string): Promise<OtpRequestResponse> {
  const { data } = await http.post<OtpRequestResponse>('/admin/auth/otp/request/', { email });
  return data;
}

/** Issues admin-scope tokens; 403 `not_staff` for non-staff, OTP errors per SPEC §5.0. */
export async function verifyAdminOtp(email: string, code: string): Promise<AdminOtpVerifyResponse> {
  const { data } = await http.post<AdminOtpVerifyResponse>('/admin/auth/otp/verify/', { email, code });
  return data;
}

export async function fetchAdminMe(signal?: AbortSignal): Promise<AdminMe> {
  const { data } = await http.get<AdminMe>('/admin/me/', { signal });
  return data;
}

/** Blacklists the refresh token server-side (best effort on sign-out). */
export async function revokeRefreshToken(refresh: string): Promise<void> {
  await http.post('/auth/logout/', { refresh });
}
